module.exports = __webpack_public_path__ + "img/113.ae6578d1.jpg";